export default __webpack_public_path__ + "static/bg-f2569412ac8ac07ccf846adec635a0d7.svg";